import { gql } from '@apollo/client';

export const GET_WITHDRAWAL_FOR_PENDING_APPROVALS = gql`
  query GET_WITHDRAWAL_FOR_PENDING_APPROVALS(
    $ids: [ID!]
    $projectIds: [ID!]
    $status: [ApplicationStatus!]
  ) {
    withdrawals(ids: $ids, projectIds: $projectIds, status: $status) {
      id
      project {
        id
        title
        profile {
          projectCode
        }
        projectStatus {
          id
          name
          controlType
        }
      }
      isCurrentAppointedApprover
      date
      justification
      status
    }
  }
`;

export const GET_VIREMENTS_FOR_PENDING_APPROVALS = gql`
  query GET_VIREMENTS_FOR_PENDING_APPROVALS(
    $ids: [ID!]
    $projectIds: [ID!]
    $status: [ApplicationStatus!]
    $pageSize: Int
  ) {
    virements(
      ids: $ids
      projectIds: $projectIds
      status: $status
      pageSize: $pageSize
    ) {
      id
      project {
        id
        title
        profile {
          projectCode
        }
        projectStatus {
          id
          name
          controlType
        }
      }
      isCurrentAppointedApprover
      date
      fromBudget {
        id
        budgetCategory {
          id
          name
        }
      }
      toBudget {
        id
        budgetCategory {
          id
          name
        }
      }
      amount
      status
    }
  }
`;

export const GET_PROPOSAL_REVISIONS_FOR_PENDING_APPROVALS = gql`
  query GET_PROPOSAL_REVISIONS_FOR_PENDING_APPROVALS(
    $ids: [ID!]
    $projectIds: [ID!]
    $status: [ApplicationStatus!]
  ) {
    proposalRevisions(ids: $ids, projectIds: $projectIds, status: $status) {
      id
      project {
        id
        title
        profile {
          projectCode
        }
        projectStatus {
          id
          name
          controlType
        }
      }
      isCurrentAppointedApprover
      date
      highlights
      justification
      status
    }
  }
`;

export const GET_EXTENSIONS_FOR_PENDING_APPROVALS = gql`
  query GET_EXTENSIONS_FOR_PENDING_APPROVALS(
    $ids: [ID!]
    $projectIds: [ID!]
    $status: [ApplicationStatus!]
  ) {
    extensions(ids: $ids, projectIds: $projectIds, status: $status) {
      id
      project {
        id
        title
        profile {
          projectCode
        }
        projectStatus {
          id
          name
          controlType
        }
      }
      isCurrentAppointedApprover
      date
      newCompletionDate
      justification
      status
    }
  }
`;

export const GET_REPORT_SUBMISSIONSS_FOR_PENDING_APPROVALS = gql`
  query GET_REPORT_SUBMISSIONSS_FOR_PENDING_APPROVALS(
    $ids: [ID!]
    $projectIds: [ID!]
    $reportSubmissionStatus: [ReportSubmissionStatus!]
    $reportType: [ReportType!]
    $projectStatus: [ID!]
    $pageSize: Int
    $current: Int
    $needMyApproval: Boolean
    $keyword: String
  ) {
    reportSubmissionConnection(
      ids: $ids
      projectIds: $projectIds
      reportSubmissionStatus: $reportSubmissionStatus
      reportType: $reportType
      projectStatus: $projectStatus
      pageSize: $pageSize
      current: $current
      needMyApproval: $needMyApproval
      keyword: $keyword
    ) {
      totalCount
      nodes {
        id
        project {
          id
          title
          profile {
            projectCode
          }
          projectStatus {
            id
            name
            controlType
          }
        }
        reportType
        scheduledSubmissionDate
        reportingPeriod
        status
        actualSubmissionDate
        remarks
        isCurrentAppointedReviewer
      }
    }
  }
`;

export const GET_PENDING_APPROVALS = gql`
  fragment Data on Project {
    id
    title
    profile {
      projectCode
      department {
        id
        abbreviation
      }
    }
    projectStatus {
      id
      controlType
    }
  }
  query GET_PENDING_APPROVALS {
    myPendingApprovals {
      extensions {
        id
        project {
          ...Data
        }
        isCurrentAppointedApprover
        status
        date
      }
      proposalRevisions {
        id
        project {
          ...Data
        }
        isCurrentAppointedApprover
        status
        date
      }
      virements {
        id
        project {
          ...Data
        }
        isCurrentAppointedApprover
        status
        date
      }
      withdrawals {
        id
        project {
          ...Data
        }
        isCurrentAppointedApprover
        status
        date
      }
      reportSubmissions {
        id
        reportType
        project {
          ...Data
        }
        isCurrentAppointedReviewer
        date
        status
      }
    }
    projectApplications(
      status: [PENDING]
      showPriorities: [0]
      isCurrentEndorser: true
      pageSize: 10
      current: 1
    ) {
      totalCount
      nodes {
        id
        refNumber
        title
        firstSubmissionDate
        hostDepartment {
          id
          abbreviation
        }
        currentEndorsement {
          date
        }
      }
    }
  }
`;
